module.exports = __webpack_public_path__ + "img/image3.c5302288.jpg";